import React from 'react';
export function SymptomsSection() {
  return <section className="bg-gradient-hero py-16 md:py-20 px-5 md:px-8" data-id="element-367" data-mp="3m583tb1wc66r">
      <div className="max-w-[1400px] mx-auto flex flex-col items-center text-center" data-id="element-368" data-mp="b4h3vznaczgi">
        <div className="text-center max-w-md mx-auto" data-id="element-369" data-mp="3sms7ev53j7lm">
          <h3 className="font-display text-[32px] leading-tight text-foreground" data-id="element-370" data-mp="3sk608wm4au3x">
            ¿Te reconocés en alguna de estas situaciones?
          </h3>

          <ul className="mt-8 space-y-6 text-left" data-id="element-371" data-mp="3jk93s8thkqyb">
            <li className="font-body text-foreground/80" data-id="element-372" data-mp="3nmxfqpdhydzi">
              <p className="text-[18px]" data-id="element-373" data-mp="3nogwsi6z8t2c">— Dormís pero no descansás.</p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-374" data-mp="39nxt1n9jo95z">
                Ocho horas y aun así necesitás café para funcionar.
              </p>
            </li>

            <li className="font-body text-foreground/80" data-id="element-375" data-mp="17vrn8dvau5zp">
              <p className="text-[18px]" data-id="element-376" data-mp="17wb03g63e46v">
                — Tu cintura cambió aunque comés parecido.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-377" data-mp="1csrswno8l6qa">
                La ropa que antes te quedaba bien hoy no cierra igual.
              </p>
            </li>

            

            <li className="font-body text-foreground/80" data-id="element-378" data-mp="2wfny85d28i2v">
              <p className="text-[18px]" data-id="element-379" data-mp="3a83sohrwb7s6">— Ansiedad, antojos e hinchazón.</p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-380" data-mp="367tkqzkjm7ao">
                Aparecen a la tarde, sin aviso, y cuesta pararlos.
              </p>
            </li>

            

            <li className="font-body text-foreground/80" data-id="element-381" data-mp="2diw8pe6xd6qd">
              <p className="text-[18px]" data-id="element-382" data-mp="2dkh230hi6jmn">
                — Te exigís igual pero tu cuerpo ya no responde igual.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-383" data-mp="2rgb36xc1c4p7">
                Ponés el mismo esfuerzo de siempre y los resultados ya no
                llegan.
              </p>
            </li>
          </ul>

          {/* Imagen — cierre emocional del espejo, no apertura */}
          <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ChatGPT_Image_9_jun_2026_02_48_17_p.m_430x.jpg?v=1781031076" alt="Mujer reflexionando" loading="lazy" decoding="async" className="w-full max-w-[430px] mx-auto rounded-xl mt-10" data-id="element-384" data-mp="1vg19i670y6u" />

          {/* Closing card — cierra el espejo emocional y da paso al cambio de creencia */}
          

          <div className="mt-10" data-id="element-385" data-mp="39k1mr5wf2tg7">
            <p className="font-display text-[34px] leading-tight text-foreground" data-id="element-386" data-mp="39j09curxhuvb">
              No necesitás esforzarte más.
            </p>

            <p className="font-display italic text-[#C8A870] text-[30px] leading-tight mt-2" data-id="element-387" data-mp="2gvxf4euac6av">
              Necesitás entender qué cambió.
            </p>
            <div className="mt-8 mb-10 max-w-md mx-auto text-center" data-id="element-388" data-mp="2ltfcr92uqz3k"></div>
          </div>
        </div>
      </div>
    </section>;
}